import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid, GridAutoSizing, GridId } from 'view/components/datagrid'
import { tradingLimitsGridOptions } from './TradingLimitsGridModel'
import { createGetTradingLimitCurrenciesUserSelector, tradingLimitTypeUserSelector } from 'selectors/userSelectors'

import { useFilteredTradingLimitsColumnDefs, useGetTradingLimitsRows } from '../utils'
import { useAuthorisedUser, useUser } from 'view/hooks'
import { identityPropsSelector, useParametricSelector } from 'utils'

const getTradingLimitCurrenciesUserSelector = createGetTradingLimitCurrenciesUserSelector(identityPropsSelector)

export const TradingLimitsGrid: React.FunctionComponent = () => {
  const authorisedUser = useAuthorisedUser()
  const currentUser = useUser(authorisedUser.id)

  const tradingLimitType = useSelector(tradingLimitTypeUserSelector)
  const tradingLimitsUserUtilisation = useParametricSelector(getTradingLimitCurrenciesUserSelector, authorisedUser.id)
  const tradingLimits = useGetTradingLimitsRows(currentUser, tradingLimitsUserUtilisation)

  const filteredColumnDefs = useFilteredTradingLimitsColumnDefs(tradingLimitType)
  return (
    <DataGrid
      gridId={GridId.SalesCoverageGrid}
      gridOptions={tradingLimitsGridOptions}
      gridColumnAutoSizing={GridAutoSizing.NONE}
      disableGrouping={true}
      columnDefs={filteredColumnDefs}
      rowData={tradingLimits}
    />
  )
}
